
import { postData, getData, deleteData } from '../apiClient';

// get all phrases
export const getPhrases = async ({ page = 1, limit = 10, search = '' }) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/phrase/get?${queryParams}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get phrases API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// create new phrase
export const createPhrase = async ({ phrase }) => {
    try {
        const result = await postData('/phrase/create', {
            phrase: phrase.trim(),
        });
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Create phrase API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// delete phrase
export const deletePhrase = async (id) => {
    try {
        const result = await deleteData(`/phrase/delete/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Delete phrase API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};
